import { Injectable } from '@angular/core';
import { HttpDataService } from '@app/shared/http/http-data.service';

import { ICodeValue, IContact } from '@type_definitions/datatypes';
import { TranslationService } from '@app/shared/translation/translation.service';

export interface IAcslInfo {
  od:IContact;
  bpDeskTeamLead:IContact;
  gbdm:IContact;
  ranking:ICodeValue;
  rankingServices:ICodeValue;
  coverageStatus:ICodeValue;
  coverageComment:string;
  autoCloseOrders:boolean;
  approvalForNewWebshops:boolean;
  operational:boolean;
  weekUrgencies:string;
  timeSlot:string;
  success:string;
  weaknesses:string;
  companyInfo:string;
  backupInfo:string;
  swot:string;
  specificInstructions:string;
  bpAssessment:string;
  strengths:string;
  weekOpenItems:string;
  checkDate:string;
  checkAuthor:IContact;
  checkComments:string;
  fullyResponsive:boolean;
  updatesGA:boolean;
  qualityKPI:boolean;
  progress:number;
}

@Injectable()
export class BPProfilesAcslInfoDataService {
  constructor(
    private httpDataService:HttpDataService,
    private translationService:TranslationService
  ) {
    /**/
  }

  public getAcslInfo(profileId:number):Promise<IAcslInfo> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/acslinfo`,
      {},
      undefined,
      'Error loading info'
    );
  }

  public saveAcslInfo(profileId:number, data:IAcslInfo):Promise<IAcslInfo> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/acslinfo`,
      {},
      data,
      this.translationService.instant('GA.GENERAL.SAVING', { label: 'info' }),
      'Error loading info'
    );
  }
}